import React from "react";
import { theme } from "@src/components/nessie-web";
import { Flex } from "@src/components/Boxes";
import Translate from "@src/components/translation/Translate";
import { AnchorScroll } from "@src/components/AnchorScroll";
import styled from "@emotion/styled/base";

const navData = [
  {
    href: "#teachers",
    translationKey: "directus.page_resources.link_teachers",
  },
  {
    href: "#leaders",
    translationKey: "directus.page_resources.link_leaders",
  },
  {
    href: "#parents",
    translationKey: "directus.page_resources.link_parents",
  },
];

const NoBulletLi = styled("li")`
  list-style-type: none;
`;

const NavLink = ({ href, children }) => <AnchorScroll href={href}>{children}</AnchorScroll>;

const NavSection: React.FC = () => {
  return (
    <Flex
      as="ul"
      flexDirection={["column", "row"]}
      justifyContent="center"
      alignItems="center"
      paddingTop={["10px", "20px"]}
      paddingBottom={["10px", "20px"]}
      backgroundColor={theme.colors.aqua10}
      marginBottom={["30px", "60px"]}
    >
      {navData.map((item, index) => (
        <NoBulletLi key={index}>
          <NavLink href={item.href}>
            <Translate path={item.translationKey} />
          </NavLink>
        </NoBulletLi>
      ))}
    </Flex>
  );
};

export default NavSection;
